// Copyright (c) StrangeBee 2023

import moment from 'moment';

export const dateOperator: Record<string, string> = {
    custom: 'Custom',
    today: 'Today',
    last7days: 'Last 7 days',
    last30days: 'Last 30 days',
    last3months: 'Last 3 months',
    last6months: 'Last 6 months',
    lastyear: 'Last year',
};

export const normalizeDate = (date: moment.Moment): number => date?.valueOf();
